/**
 * Auto-activate "In-stock" filter on collection page load
 * Only activates when no other filters are active
 * Works in conjunction with filters.liquid which pre-checks the checkbox
 */
(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoInstockFilter);
  } else {
    initAutoInstockFilter();
  }

  function initAutoInstockFilter() {
    // Check if we're on a collection or search page with filters
    const filterForm = document.querySelector('[data-collection-filters-form]');
    if (!filterForm) return;

    // Get current URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    
    // Check if any filters are already active in URL
    let hasActiveFilters = false;
    for (let [key, value] of urlParams.entries()) {
      if (key.includes('filter.')) {
        hasActiveFilters = true;
        break;
      }
    }

    // If filters are already active, don't auto-activate
    if (hasActiveFilters) return;

    // Find checkboxes that are checked but not in the URL (auto-checked by liquid)
    const filterInputs = filterForm.querySelectorAll('input[type="checkbox"]:checked');
    let autoCheckedInstock = null;

    filterInputs.forEach(input => {
      // Check if this checkbox's parameter is not in the URL (meaning it was auto-checked)
      if (!urlParams.has(input.name)) {
        const label = input.nextElementSibling;
        if (label) {
          const labelText = label.textContent.trim().toLowerCase();
          // Check for common "in stock" variations
          if (labelText === 'in stock' || 
              labelText === 'in-stock' || 
              labelText === 'instock') {
            autoCheckedInstock = input;
          }
        }
      }
    });

    // If we found an auto-checked in-stock filter, trigger the form update
    if (autoCheckedInstock) {
      // Add the filter to the URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set(autoCheckedInstock.name, autoCheckedInstock.value);
      
      // Update browser history without reloading
      window.history.replaceState({}, '', newUrl.toString());
      
      // Trigger the collection filter form to update the products
      const collectionFiltersForm = filterForm.closest('collection-filters-form');
      if (collectionFiltersForm) {
        // Trigger an input event to update the collection
        const event = new Event('input', { bubbles: true });
        autoCheckedInstock.dispatchEvent(event);
      }
    }
  }
})();
